const waitForElement = (
  elementFinder: () => HTMLElement | null | undefined,
  timeout = 1000,
  interval = 10,
): Promise<HTMLElement> =>
  new Promise((resolve, reject) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timeoutRef: any = null;
    const intervalRef = setInterval(() => {
      const element = elementFinder();

      if (element) {
        if (timeoutRef !== null) {
          clearTimeout(timeoutRef);
        }

        clearInterval(intervalRef);
        resolve(element);
      }
    }, interval);
    timeoutRef = setTimeout(() => {
      clearInterval(intervalRef);
      reject();
    }, timeout);
  });

// eslint-disable-next-line import/no-default-export
export default waitForElement;
